import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator } from '@angular/material';
import { Globals } from 'src/app/globals';
import { UsuarioService } from 'src/app/vista-admin-usuario/servicios/usuario.service';
import { ConsultarPreguntasService } from '../consultar-preguntas.service';
import { Router } from '@angular/router';
import jspdf  from 'jspdf';  
import html2canvas from 'html2canvas';  

@Component({
  selector: 'app-resumen-conflictos',
  templateUrl: './resumen-conflictos.component.html',
  styleUrls: ['./resumen-conflictos.component.css']
})
export class ResumenConflictosComponent implements OnInit {
  dataSource = new MatTableDataSource([]);

  loading = true;

  anio_actual = new Date().getFullYear();
  texto_cabecera = '';
  texto_subtitulo = '';
  existeInformacion=false;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ["nombre", "correo", "posicion"];
  conflictos_ok = null;
  texto_boton_finalizar: string = '';
  
  constructor(private userService: UsuarioService,
              private ConsultarPreguntas: ConsultarPreguntasService,
              private router:Router,
              public globals: Globals) {
    //////conole.log('Globals:',this.globals);

    if ( this.globals.lenguaje == "en" || this.globals.lenguaje == "ingles" ) {                
      this.globals.lenguaje = "en";        
    } else {
      this.globals.lenguaje = "es";            
    }

  }

  ngOnInit() {
    this.ConsultarConflictos();
    if(this.globals.lenguaje == 'es'){
      this.texto_cabecera = 'Gracias por diligenciar la Encuesta de Conflictos de Interés';
      this.texto_subtitulo = 'A continuación podrás ver tus respuestas';
      this.texto_boton_finalizar = 'Finalizar Encuesta';
    }else{
      this.texto_cabecera = 'Thank you for completing the Survey of Conflicts of Interest';
      this.texto_subtitulo = 'Below you can see your answers';
      this.texto_boton_finalizar = 'Exit Survey';
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  gotoHome(){
    //////conole.log('To Home, Now!')
    this.router.navigate(["/inicio"]);
  }

  ConsultarConflictos() {

    this.ConsultarPreguntas.ConsultarConflictoResumen(this.globals.IdFuncionarioTablaFuncionarios, 1).subscribe(result => {
      this.conflictos_ok = result;
       //////conole.log('Resultado QUERY:',result);
       //console.log(result)
      let con = 0;

      this.conflictos_ok.forEach(el => {

        if(con>0){
          let response=true;
          let nombre_pregunta = '';
          let desc_pregunta   = '';
          let aclaracion_preg = '';
          let tipo_pregunta   = null;

          tipo_pregunta   = el.tipo_desc.TipoPregunta; 
          //////conole.log("TIPO PREGUNTA",el)

          //Datos de Pregunta
          if(this.globals.lenguaje == 'es'){
            nombre_pregunta = el.tipo_desc.nombre;
            desc_pregunta   = el.tipo_desc.tipo_conflicto_espanol;
            aclaracion_preg = el.tipo_desc.DescripcionPregunta;
          }else{
            nombre_pregunta = el.tipo_desc.ingles;
            desc_pregunta   = el.tipo_desc.tipo_conflicto_ingles;
            aclaracion_preg = el.tipo_desc.InglesDescripcionPregunta;
          }

          // Texto1ES 
          // Texto1EN

          el.tipo_conflicto = desc_pregunta;
          el.desc_pregunta = nombre_pregunta;
          el.aclaracion_preg = aclaracion_preg;

          if(tipo_pregunta == 4){

            let parts_desc_ack = "";

            //Descripcion Manifiestos
            if(this.globals.lenguaje == 'es'){
              if(el.tipo_desc.Texto1ES != " " && el.tipo_desc.Texto2ES != " " && el.tipo_desc.Texto3ES != " " && el.tipo_desc.Texto4ES != " " && el.tipo_desc.Texto5ES != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1ES+"</li><li>"+el.tipo_desc.Texto2ES+"</li><li>"+el.tipo_desc.Texto3ES+"</li><li>"+el.tipo_desc.Texto4ES+"</li><li>"+el.tipo_desc.Texto5ES+"</li></ul>";
              }else if(el.tipo_desc.Texto1ES != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1ES+"</li></ul>";
              }
            }else{
              if(el.tipo_desc.Texto1EN != " " && el.tipo_desc.Texto2EN != " " && el.tipo_desc.Texto3EN != " " && el.tipo_desc.Texto4EN != " " && el.tipo_desc.Texto5EN != " "){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1EN+"</li><li>"+el.tipo_desc.Texto2EN+"</li><li>"+el.tipo_desc.Texto3EN+"</li><li>"+el.tipo_desc.Texto4EN+"</li><li>"+el.tipo_desc.Texto5EN+"</li></ul>";
              }else if(el.tipo_desc.Texto1EN != " " ){
                parts_desc_ack = "<ul><li>"+el.tipo_desc.Texto1EN+"</li></ul>";
              }
            }

            let descripcion_ack = parts_desc_ack;
            el.descripcion_ack = descripcion_ack;
            //////conole.log("CLAUSULA",el.descripcion_ack)
          }
          

          // //////conole.log('Pregunta:',nombre_pregunta,'Descripcion:',desc_pregunta);
          let json_data = [];
          let headers_data = [];
          let headers = [];

          if(tipo_pregunta == 3){
            // if(el.idtbl_conflicto == 12){ //Comentado para descartar tipo 12
              // el.respuesta = [el.respuesta[1]];
            // }else{
              el.respuesta = [el.respuesta[0]];
            // }
          }else if(tipo_pregunta == 4){
            el.respuesta = [el.respuesta[0]];
          }

          el.respuesta.forEach(rs => {

            let arr_header = [];
            let arr_valor = [];

            //Si el tipo es dilema etico o manifiesto, tome la primera opcion (Ultima respuesta diligenciada)
            if(tipo_pregunta == 3 ){
                if(rs){
                  rs = [rs[1]];
                }
                
            }else if(tipo_pregunta == 4 ){
              if(rs){
                rs = [rs];
              }

            }

            

            // //////conole.log(tipo_pregunta,'RS Modificado:',rs)

            let anio = '';
            if(rs){
              rs.forEach(rsdet => {

                //Skip Respuesta tipo Vigencia del Conflicto
                //if(rsdet.id_tipo_respuesta == 32){
                  //return;
                //}
                
                if(rsdet && rsdet.idtbl_respuestas_adicionales != '0'){
  
                  if(tipo_pregunta == 4){
                    if(this.globals.lenguaje == 'es'){
                      rsdet.nombre = 'Acepta Manifestación de Cumplimiento';
                    }else{
                      rsdet.nombre = 'Accept Terms and Conditions'
                    }
  
                    
                  }
  
                  let header = '';
                  if(this.globals.lenguaje == 'es'){
                    header = rsdet.nombre;
                  }else{
                    header = rsdet.ingles;
                  }
  
                  let valor = rsdet.valor;

                  if(rsdet.id_tipo_respuesta == "35" || rsdet.id_tipo_respuesta == "36"){
                    if(valor){
                      valor = valor.split('T')[0];
                    }
                  }

                  anio = rsdet.annio;
  
                  arr_header.push(header);
                  arr_valor.push(valor);
                  // //////conole.log('Header:',header,'Valor:',valor);
  
                }
              });
              this.existeInformacion=true;

            }else{
              //////conole.log('No se ha definido un RS. No hay data registrada')
              this.existeInformacion=false;
              let label_not_data = '';
              if(this.globals.lenguaje == 'es'){
                label_not_data = 'No existen datos';
              }else{
                label_not_data = 'No data';
              }
              rs = [{valor: label_not_data,nombre:' '}];
              arr_header.push(' ');
              arr_valor.push(label_not_data);
            }
            

            // //////conole.log('Before Set Año:',anio)

            if(anio != '' && tipo_pregunta == 2){
              //////conole.log("TI 2",el)
              let label_anio = '';

              if(this.globals.lenguaje == 'es'){
                label_anio = 'Año';
              }else{
                label_anio = 'Year'
              }
              arr_header.push(label_anio);
              arr_valor.push(anio);
              // //////conole.log('Agrega AÑO:',anio)
            }
           
            
            if(rs){
              rs.arr_header = arr_header;
              rs.arr_valor = arr_valor;
            }
            //////conole.log("RESPUESTA RS =>>>>",rs)
            headers = arr_header;
            
            let json = [];
            for (let index = 0; index < arr_header.length; index++) {
              let head = arr_header[index];
              
              json[index] = arr_valor[index];
             
            }
            //json_data.push(json)
            if(headers.length!=0){
             
              
              json_data.push(json)
              headers_data.push(headers)
            }else{

             
              let label = [''];

              if(this.globals.lenguaje == 'es'){
                label = ['¿Tiene nuevos conflictos de interés en el presente año?'];
                
              }else{
                label = ['Do you have new conflicts of interest this year?']
              }
              
              let valor = ['No'];
              let json_std = {}
              //json_std[label] = valor; 
              let valida_push = true;
              for(let i = 0; i < headers_data.length; i++){
                ////conole.log('primer dato ', headers_data[i], label);
                let dato_header = headers_data[i];
                if(dato_header[0] == label[0]){
                  valida_push = false;
                }
              }

              if(valida_push){
                json_data.push(valor);
                headers_data.push(label);
              }
           
            }
          });
          
          //Casos donde no hay respuesta
          if(!el.respuesta.length && tipo_pregunta == 2){

            let label = [''];

            if(this.globals.lenguaje == 'es'){
              label = ['¿Tiene nuevos conflictos de interés en el presente año?'];
            }else{
              label = ['Do you have new conflicts of interest this year?']
            }

            let valor = ['No'];
            let json_std = {}
            //json_std[label] = valor; 
            let valida_push = true;
            for(let i = 0; i < headers_data.length; i++){
              ////conole.log('segundo dato ', headers_data[i], label);
              let dato_header = headers_data[i];
              
              if(dato_header[0] == label[0]){
                valida_push = false;
              }
            }

            if(valida_push){
              json_data.push(valor);
              headers_data.push(label);
            }
            
          }
          
        
          el.json_data = json_data;
          el.headers = headers_data;
          
          let validar_eliminar_no = false;
          
          for(let e of el.respuesta){
            //console.log(e);
            if(e.length > 0){
              if(e[0].origen != 0){
                if(e[0].origen == 1){
                  validar_eliminar_no = true;
                }
              }else{
                if(e.length > 1){
                  if(e[1].origen == 1){
                    validar_eliminar_no = true;
                  }
                }
              }
            }
          }
          
          if(validar_eliminar_no){
            for(let i = 0; i < el.json_data.length; i++){
              let e = el.json_data[i];
              //console.log("Elemento posición 0 ", e[0]);
              if(e[0] == 'No'){
                el.json_data.splice(i, 1);
                el.headers.splice(i, 1);
              }
            }            
          }
         
          
        }
        con += 1;
      });

      // //////conole.log('Con POSTerior:',this.conflictos_ok)
      this.loading = false;
    });

  }


  generarPDF(){
   
     // Extraemos el
     const DATA = document.getElementById('content');
     const doc = new jspdf('p', 'pt', 'a4');
     const options = {
       background: 'white',
       scale: 3
     };
     html2canvas(DATA, options).then((canvas) => {
 
       const img = canvas.toDataURL('image/PNG');
 
       // Add image Canvas to PDF
       const bufferX = 15;
       const bufferY = 15;
       const imgProps = (doc as any).getImageProperties(img);
       const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferX;
       const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
       doc.addImage(img, 'PNG', bufferX, bufferY, pdfWidth, pdfHeight, undefined, 'FAST');
       return doc;
     }).then((docResult) => {
       docResult.save("doc.pdf");
     });
   }

}
